import { Icon } from '@acpaas-ui/react-components';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import notificationsActions from '../../../actions/notifications.actions';
import { NOTIFICATION_MESSAGE_KEY } from '../../../constants/notifications.constants';
import { useOutsideClick } from '../../../hooks/useOutsideClick.hook';
import { NOTIFICATIONS_RESOURCE } from '../../../resources/notifications.resource';
import { tableDataSelector } from '../../../selectors/resources.selectors';
import socketService from '../../../services/socket.service';
import Flyout from '../../core/Flyout';
import HeaderNotificationsList from './HeaderNotificationsList';

const HeaderNotifications = () => {
  const dispatch = useDispatch();
  const flyoutRootRef = useRef(null);
  const { data, config } = useSelector((state) => tableDataSelector(state, { resource: NOTIFICATIONS_RESOURCE }));
  const [right, setRight] = useState(document.getElementById('mtn-header-top-menus')?.offsetWidth ?? 0);
  const [isOpen, setIsOpen] = useState(false);
  const unreadCount = data?.filter((n) => !n.acknowledged)?.length;
  const canLoadMore = config?.total / config?.size > 1;

  const close = () => {
    if (isOpen) {
      dispatch(notificationsActions.acknowledge());
      setIsOpen(false);
    }
  };

  const { elRef } = useOutsideClick((clickedElement) => {
    if (
      clickedElement === flyoutRootRef.current ||
      (flyoutRootRef.current?.contains(clickedElement) && clickedElement !== elRef.current)
    ) {
      return;
    }
    close();
  });

  useLayoutEffect(() => {
    setRight(document.getElementById('mtn-header-top-menus')?.offsetWidth ?? 0);

    const listener = (e) => {
      setRight(document.getElementById('mtn-header-top-menus')?.offsetWidth ?? 0);
    };

    window.addEventListener('resize', listener);

    return () => {
      window.removeEventListener('resize', listener);
    };
  }, []);

  useEffect(() => {
    socketService.setup();
    socketService.subscribe(NOTIFICATION_MESSAGE_KEY, (newNotifications) => {
      dispatch(notificationsActions.setReceivedNotifications(newNotifications));
    });

    return () => {
      socketService.disconnect();
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(notificationsActions.getForCurrentUser());
  }, [dispatch]);

  return (
    <>
      <div
        ref={flyoutRootRef}
        className="spo-m-header-notifications"
        style={{ right }}
        onClick={() => (isOpen ? close() : setIsOpen(true))}
      >
        <div className={`spo-m-header-notifications__icon ${unreadCount > 0 ? 'has-unread' : ''}`}>
          <Icon name="ai-alarm-bell" />
        </div>
        {unreadCount > 0 && <div className="spo-m-header-notifications__unread-indicator"></div>}
        <Flyout rootElement={flyoutRootRef.current} isOpen={isOpen}>
          <div ref={elRef} className="spo-m-header-notifications__list">
            <HeaderNotificationsList canLoadMore={canLoadMore} notifications={data} />
          </div>
        </Flyout>
      </div>
    </>
  );
};

export default HeaderNotifications;
